
import { defineComponent, PropType, ref } from "vue";

export default defineComponent({
  name: "AppSubmenu",
  emits: ["menuitem-click"],
  props: {
    items: Array as PropType<any[]>,
    root: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const activeIndex = ref<number | null>(null);
    return { activeIndex };
  },
  methods: {
    onMenuItemClick(event: any, item: any, index: number) {
      if (item.disabled) {
        event.preventDefault();
        return;
      }
      if (!item.to && !item.url) {
        event.preventDefault();
      }
      //execute command
      if (item.command) {
        item.command({ originalEvent: event, item: item });
      }
      this.activeIndex = index === this.activeIndex ? null : index;
      this.$emit("menuitem-click", {
        originalEvent: event,
        item: item,
      });
      console.log(this.activeIndex);
    },
    visible(item: any) {
      return typeof item.visible === "function"
        ? item.visible()
        : item.visible !== false;
    },
  },
  components: {
    AppSubmenu: this,
  },
});
